var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-img',{attrs:{"src":require("../../assets/loading.gif"),"lazy-src":require("../../assets/loading.gif"),"aspect-ratio":"1","max-width":"300px"}})
}
var staticRenderFns = []

export { render, staticRenderFns }